import React from 'react'
import { Link } from 'react-router-dom';
import { FaCalendarDay } from "react-icons/fa";
import { useState, useEffect, useRef } from 'react';

function getDate() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    //return `${month}/${date}/${year}`;
    return `${year}`;
  }

  function getDay() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    //return `${month}/${date}/${year}`;
    return `${date}`;
  }

  function getMonthToShow() {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1; // 1-based (January = 1)
    const currentDay = currentDate.getDate();
  
    let monthToShow;
    if (currentDay > 5) {
      // Show current month
      monthToShow = currentMonth;
    } else {
      // Show previous month
      monthToShow = currentMonth === 1 ? 12 : currentMonth - 1;
    }
  
    // Format the month to always display two digits
    return monthToShow.toString().padStart(2, '0');
  }
  

export default function Footer() {
 
    const [currentDate, setCurrentDate] = useState(getDate());  
    const [currenMonth, setCurrentMonth] = useState(getMonthToShow());  
    
  return (
    <>
        
   
        <footer className="footer_area">
       
        <div className="container">
            <div className="row">
                <div className="col-12 col-sm-12 col-lg-3">
                    <div className="fotter_content text-center">
                      <Link to=""><img loading="lazy" src={`https://magazine.issuewire.com/${currentDate}/${currenMonth}/pages/1.jpg`} alt="IssueWire Magazine" className="MagazineImage"  /></Link>
                        
                
                    </div>
                </div>
                
                <div className="col-4 col-sm-4 col-lg-2">
                    <div className="fotter_content">
                        
                        

                        <ul>
                        <li className="b_trendingtext"><Link to="https://www.issuewire.com/signup" alt="IssueWire" title="Issuewire">Sign Up</Link></li>
                        <li className="b_trendingtext"><Link to="https://www.issuewire.com/userlogin" title="userlogin">Log In</Link>
                        </li>
                        <li className="b_trendingtext"><Link to="https://www.issuewire.com/signup/pricingdetails" title="pricingdetails"> Pricing</Link></li>
                        <li className="b_trendingtext"><Link to="https://www.issuewire.com/writing" title="writing"> Writing</Link>
                        </li>

                        <li className="b_trendingtext"><Link to="https://www.issuewire.com/press-release-distribution" title="press-release-distribution">Distribution</Link></li>
                        <li className="b_trendingtext"><Link to="https://www.issuewire.com/blog" title="blog">Blog</Link></li>

                    </ul>


                    </div>
                </div>
                <div className="col-4 col-sm-4 col-lg-2">
                    <div className="fotter_content">
                        

                       

                        <ul >


                        <li className="b_trendingtext"><Link to="https://www.issuewire.com/about" title="about">About Us</Link></li>
                        <li className="b_trendingtext"><Link to="https://www.issuewire.com/how-to-work" title="how-to-work">How It
                                Works</Link></li>
                        <li className="b_trendingtext"><Link to="https://www.issuewire.com/editorial-guideline" title="editorial-guideline">Editorial</Link></li>


                        <li className="b_trendingtext"><Link to="https://www.issuewire.com/terms-of-service" title="terms-of-service">Terms</Link></li>
                        <li className="b_trendingtext"><Link to="https://www.issuewire.com/privacy-policy" title="privacy-policy">Privacy</Link></li>
                        <li className="b_trendingtext"><Link to="https://www.issuewire.com/contact" title="contact">Contact Us</Link>
                        </li>

                    </ul>

                    
                    </div>
                </div>
                <div className="col-4 col-sm-4 col-lg-2">
                    <div className="fotter_content">
                       

                       

                        <ul >


<li className="b_trendingtext"><Link to="https://www.issuewire.com/newsroom" title="newsroom">News Room</Link>
</li>

<li className="b_trendingtext"><Link to="https://www.issuewire.com/media" title="media">Journalist</Link></li>



<li className="b_trendingtext"><Link to="https://www.issuewire.com/testimonials" title="testimonials">Testimonial</Link></li>
<li className="b_trendingtext"><Link to="https://www.issuewire.com/faq" title="faq">Faq</Link></li>
<li className="b_trendingtext"><Link to="https://www.issuewire.com/sitemaporg.xml" title="sitemaporg">Sitemap</Link></li>

</ul>

                    
                    </div>
                </div>
                <div className="col-12 col-sm-12 col-lg-3">
                    <div className="fotter_content text-center">
                    <p className="prightqs">ABOUT US </p>

<p><b className="prightqs"><i className="fa fa-envelope" aria-hidden="true"></i>Have any
        questions?</b><br />
    <span className="prightadd">info@issuewire.com</span>
</p>
<p  className="pright">
    <Link to="https://twitter.com/Issuewired" target="_blank" title="Issuewire Twitter">
        <img loading="lazy" src="https://issuewireassets.s3.us-west-2.amazonaws.com/assets/social/twitter-x.png" alt="Twitter" title="Twitter"  /></Link>
    <Link to="https://www.facebook.com/IssueWire/" target="_blank" title="Issuewire Facebook">
        <img loading="lazy" src="https://issuewireassets.s3-us-west-2.amazonaws.com/assets/social/facebook.png" alt="Issuewire Facebook" title="Facebook"  />
    </Link>
    <Link to="https://www.youtube.com/@issuewire" target="_blank" title="Issuewire YouTube">
        <img loading="lazy" src="https://issuewireassets.s3-us-west-2.amazonaws.com/assets/social/youtube.png" alt="YouTube" title="YouTube"  /></Link>

   

    <Link to="https://www.linkedin.com/company/issuewire/" target="_blank" title="Issuewire LinkedIn">
        <img loading="lazy" src="https://issuewireassets.s3-us-west-2.amazonaws.com/assets/social/linkedin.png" alt="Issuewire LinkedIn" title="Issuewire LinkedIn"  /></Link>


    <Link to="https://www.instagram.com/issuewirepr/" target="_blank">
        <img loading="lazy" src="https://issuewireassets.s3-us-west-2.amazonaws.com/assets/social/instagram.png" title="Issuewire Instagram" alt="Instagram"  />
    </Link>
    <Link to="https://www.pinterest.com/issuewire/" target="_blank">
        <img loading="lazy" src="https://issuewireassets.s3.us-west-2.amazonaws.com/assets/social/pinterest.png" title="Issuewire Pinterest" alt="Pinterest"  />
    </Link>


</p>

                    </div>
                </div>
            </div>
        </div>
        <div className="copyrightbar">
            <div className="container">
                <p>Copyright © {currentDate} IssueWire.</p>
            </div>
        </div>
    </footer>
    
    
    </>
  )
}
